import { render, staticRenderFns } from "./SettingsHeader.vue?vue&type=template&id=12dd1047&scoped=true"
import script from "./SettingsHeader.vue?vue&type=script&lang=js"
export * from "./SettingsHeader.vue?vue&type=script&lang=js"
import style0 from "./SettingsHeader.vue?vue&type=style&index=0&id=12dd1047&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd1047",
  null
  
)

export default component.exports